import login from "./login";
import work from "./work";
import manage from "./manage";
import workmanage from "./workmanage";
import role from "./role";
import dropDownList from "./dropDownList";
import privilege from "./privilege";
import qiniu from "./qiniu";
import log from "./log";
import groupUserManage from "./groupUserManage";
import stakeholderGroup from "./stakeholderGroup";
import chat from "./chat";
import keywords from "./keywords";
import softwareHandler from "./softwareHandler";
import common from "./common";
export default {
  login,
  work,
  manage,
  workmanage,
  role,
  dropDownList,
  privilege,
  log,
  groupUserManage,
  qiniu,
  stakeholderGroup,
  chat,
  keywords,
  softwareHandler,
  common,
};
